import { IProduct } from "./interfaces/IProduct";

export default class Product implements IProduct {
  public id: string = "";
  public name: string = "";
  public type: number = 0;
  public serialNumber: string = "";
  public licenseCount: number = 1;
  public startDate: string = new Date().toISOString().substr(0, 10);
  public endDate: string = new Date(
    new Date().setDate(new Date().getDate() + 30)
  )
    .toISOString()
    .substr(0, 10);
  public showStartDatePicker: boolean = false;
  public showEndDatePicker: boolean = false;
  public tools: Array<object> = [];
  // Constructor
  constructor(id: string = "", name: string = "") {
    this.id = id;
    this.name = name;
  }
}
